
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
	import {
		orderpayOrderList
	} from '@/api/order'
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private query:any = {}
    private keywords = ''
    private paytype = null
    private paytypelist = [
      {value:null,label:'全部'},
      {value:1,label:'微信支付'},
      {value:2,label:'支付宝支付'},
    ]
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private tablelist:any = []
    private tableloading = false

    private mounted () {
      this.query = JSON.parse(JSON.stringify(this.$route.query))
      this.query.Name = decodeURIComponent(this.query.Name)
      console.log(this.query)

      this.gettablelist()
    }


    private jumpdetail(row){
      this.$router.push({
        path:'order-detail',
        query:{
          id:row.OrderNo
        }
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.paytype = null
      this.query.filterTime = this.$route.query.filterTime
      this.query.filterCheckTime = this.$route.query.filterCheckTime;
      // console.log(this.$route.query)
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          CustomerId:this.$route.query.Id,
          Keywords:this.keywords,
          PayBy:this.paytype,
					Skip:(this.pageNo-1)*this.pageSize,
					Take:this.pageSize,
        }
        if (this.query.filterTime){
					let times = this.query.filterTime.split('/');
					data.AddStartTime = times[0]
					data.AddEndTime = nextDay(times[1],1)
				}
				if (this.query.filterCheckTime){
					let times = this.query.filterCheckTime.split('/');
					data.PayStartTime = times[0]
					data.PayEndTime = nextDay(times[1],1)
				}
        let res = await orderpayOrderList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
